// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uw_O","footer":"styles_footer__3bK-c","passCodeTooltip":"styles_passCodeTooltip__3p0xW"};